import axios from 'axios';
import { CreateTemporaryPlanningProfileInput } from '../../types/create-temporary-profile-input.type';
import { UpdateTemporaryPlanningProfileInput } from '../../types/update-temporary-profile-input.type';

// PUT
// Updates temporary profiles on fishgroup.
// /ewosapi/v1/planandprognosis/temporaryprofiles/{fishGroupId}
export const putTemporaryPlanningProfiles = async (
  fishGroupId: string,
  request: CreateTemporaryPlanningProfileInput | UpdateTemporaryPlanningProfileInput
): Promise<number> => {
  await axios.put(`/ewosapi/v1/planandprognosis/temporaryprofiles/${fishGroupId}`, [request]);
  return request.id;
};
